import { computeHeadingLevel } from "@testing-library/react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { createPortal } from "react-dom";
import { useState, useEffect } from "react";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";
import { AiOutlineMinus } from "react-icons/ai";
import Creatable from "react-select/creatable";
import sendRequest from "hooks/useAxios";
import Select from "react-select";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import sendRequest2 from "hooks/useAxios2";
import toast from "react-hot-toast";

export default function AddOrderModal({ orderUpdater }) {
  const phoneNumberValidation = phoneNumber => {
    return /^09\d{9}$/.test(phoneNumber);
  };

  const checkNationalCode = national_code => {
    return /^[0-9]{10}$/.test(national_code);
  };

  const translateProductToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        if (arrayValue[index].id) {
          obj.id = arrayValue[index].id;
        } else {
          obj.title = arrayValue[index].label;
          obj.id = arrayValue[index].value;
          obj.main_price = arrayValue[index].price;
          obj.main_discount = arrayValue[index].discount;
          obj.url = arrayValue[index].choseFile;
          obj.itemcount = arrayValue[index].number;
        }

        after.push(obj.id);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = arrayValue[index].title;
        obj.value = arrayValue[index].id;
        obj.price = arrayValue[index].main_price;
        obj.discount = arrayValue[index].main_discount;
        obj.choseFile = arrayValue[index].description;
        obj.url = arrayValue[index].url;

        after.push(obj);
      }
    }

    return after;
  };
  const translateUserToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        if (arrayValue[index].id) {
          // obj.id = arrayValue[index].id;
        } else {
          // obj.title = arrayValue[index].label;
          // obj.id = arrayValue[index].value;
        }

        after.push(obj.id);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = `${arrayValue[index].fname} ${arrayValue[index].lname} _ ${arrayValue[index].mobile} `;
        obj.value = arrayValue[index].id;
        obj.mobile = arrayValue[index].mobile;

        after.push(obj);
      }
    }

    return after;
  };

  const ValidationDetailsOrder = () => {
    let isValidate = true;
    if (tempValue.number > 0) {
      setTempValidateValues(prev => {
        return { ...prev, number: true };
      });
    } else {
      setTempValidateValues(prev => {
        return { ...prev, number: false };
      });
      isValidate = false;
    }
    if (tempValue.discount >= 0) {
      setTempValidateValues(prev => {
        return { ...prev, discount: true };
      });
    } else {
      setTempValidateValues(prev => {
        return { ...prev, discount: false };
      });
      isValidate = false;
    }
    return isValidate;
  };
  const ValidationOrder = () => {
    let isValidate = true;
    // (phoneNumberValidation(addModalOrder.userName.phoneNumber))
    if (phoneNumberValidation(addModalOrder.userInfo.mobile)) {
      setValidateValues(prev => {
        return { ...prev, phoneNumber: true };
      });
    } else if (addModalOrder.user_mobile != "") {
      setValidateValues(prev => {
        return { ...prev, phoneNumber: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, phoneNumber: false };
      });
      isValidate = false;
    }

    if (phoneNumberValidation(addModalOrder.rescipient_mobile)) {
      setValidateValues(prev => {
        return { ...prev, rescipient_mobile: true };
      });
    } else if (addModalOrder.rescipient_mobile == "") {
      setValidateValues(prev => {
        return { ...prev, rescipient_mobile: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, rescipient_mobile: false };
      });
      isValidate = false;
    }
    if (checkNationalCode(addModalOrder.rescipient_postalcode)) {
      setValidateValues(prev => {
        return { ...prev, rescipient_postalcode: true };
      });
    } else if (addModalOrder.rescipient_postalcode == "") {
      setValidateValues(prev => {
        return { ...prev, rescipient_postalcode: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, rescipient_postalcode: false };
      });
      isValidate = false;
    }

    if (addModalOrder.userInfo.name) {
      setValidateValues(prev => {
        return { ...prev, userName: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, userName: false };
      });
      isValidate = false;
    }
    // if (addModalOrder.title) {
    //   setValidateValues((prev) => {
    //     return { ...prev, title: true };
    //   });
    // } else {
    //   setValidateValues((prev) => {
    //     return { ...prev, title: false };
    //   });
    //   isValidate = false;
    // }
    // if (addModalOrder.address) {
    //   setValidateValues((prev) => {
    //     return { ...prev, address: true };
    //   });
    // } else {
    //   setValidateValues((prev) => {
    //     return { ...prev, address: false };
    //   });
    // }
    // if (addModalOrder.DateSubmit) {
    //   setValidateValues(prev => {
    //     return { ...prev, DateSubmit: true };
    //   });
    // } else {
    //   setValidateValues(prev => {
    //     return { ...prev, DateSubmit: false };
    //   });
    //   isValidate = false;
    // }
    // if (addModalOrder.OrderNumber) {
    //   setValidateValues((prev) => {
    //     return { ...prev, OrderNumber: true };
    //   });
    // } else {
    //   setValidateValues((prev) => {
    //     return { ...prev, OrderNumber: false };
    //   });
    // }
    // if (addModalOrder.debtAmount) {
    //   setValidateValues((prev) => {
    //     return { ...prev, debtAmount: true };
    //   });
    // } else {
    //   setValidateValues((prev) => {
    //     return { ...prev, debtAmount: false };
    //   });
    // }
    if (addModalOrder.selectedProducts.length > 0) {
      setValidateValues(prev => {
        return { ...prev, selectedProducts: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, selectedProducts: false };
      });

      isValidate = false;
    }
    if (addModalOrder.desc) {
      setValidateValues(prev => {
        return { ...prev, desc: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, desc: false };
      });
      isValidate = false;
    }
    return isValidate;
  };
  const [validateValues, setValidateValues] = useState({
    userName: true,
    DateReceived: true,
    DatePayment: true,
    // DateSubmit: true,
    OrderNumber: true,
    debtAmount: true,
    desc: true,
    phoneNumber: true,
    selectedProducts: true,
    totalPrice: true,
    discount: true,
    price: true,
    address: true,
    rescipient_mobile: true,
    rescipient_postalcode: true
  });

  const [tempValidateValues, setTempValidateValues] = useState({
    number: true,
    discount: true
  });
  const [addModalOrder, setAddModalOrder] = useState({
    userName: "",
    DateReceived: "",
    discount: "",
    totalPrice: "",
    DatePayment: "",
    DateSubmit: "",
    OrderNumber: "",
    debtAmount: "",
    desc: "",
    user_fname: "",
    user_lname: "",
    user_mobile: "",
    phoneNumber: "",
    addProduct: "",
    products: [],
    price: "",
    address: "",
    choseFile: "",
    selectedProducts: [],
    userInfo: {},
    rescipient_fname: "",
    rescipient_lname: "",
    rescipient_mobile: "",
    rescipient_postalcode: "",
    rescipient_address: ""
  });
  // const [userOptions, setUserOptions] = useState([
  //   { value: "0", label: "ali", phoneNumber: "0901111111" },
  //   { value: "1", label: "reza", phoneNumber: "0902111111" },
  //   { value: "2", label: "hosein", phoneNumber: "0903111111" },
  // ]);
  const [defaultUser, setDefaultUser] = useState([
    { value: "create", label: "کاربر جدید" }
  ]);
  useEffect(() => {
    sendRequest("Find_users").then(data => {
      const lists = translateUserToReactSelect(data.data, false);
      setDefaultUser(prev => {
        return [...prev, ...lists];
      });
    });
  }, []);
  const [defaultProduct, setDefaultProduct] = useState([]);
  useEffect(() => {
    sendRequest("Find_products", {
      tbl_name: `left join,files,coverimg_fileid,id`
    }).then(data => {
      const lists = translateProductToReactSelect(data.data, false);
      setDefaultProduct(lists);
    });
  }, []);
  const RemoveCounter = index => {
    let newArray = addModalOrder.selectedProducts.filter(
      (value, index2, array) => {
        if (index == index2) {
          return false;
        } else {
          return true;
        }
      }
    );
    setAddModalOrder(prev => {
      return { ...prev, selectedProducts: [...newArray] };
    });
  };

  const changeHandler = (value, type) => {
    setAddModalOrder(prev => {
      return { ...prev, [type]: value };
    });
  };
  const [productList, setProductList] = useState([
    { title: "divice 1", price: 100000, id: 0, discount: 50000 },
    { title: "divice 2", price: 200000, id: 1, discount: 40000 },
    { title: "divice 3", price: 300000, id: 2, discount: 30000 }
  ]);
  const [tempValue, setTempValue] = useState({
    title: "",
    price: "",
    id: 0,
    number: 0,
    discount: 0,
    choseFile: "",
    url: ""
  });
  const [displayStatus, setDisplayStatus] = useState("d-none");

  const addOrder = () => {
    let formDataOrder = new FormData();
    for (let i = 0; i < addModalOrder.selectedProducts.length; i++) {
      // for (let j = 0; j < 3; j++) {
      // formDataOrder.append(`order_items`, {
      //   productsid: addModalOrder.selectedProducts[i].value,
      //   number: addModalOrder.selectedProducts[i].number,
      //   discount: addModalOrder.selectedProducts[i].discount,
      // });
      formDataOrder.append(
        `order_items[${i}][productid]`,
        addModalOrder.selectedProducts[i].value
      );
      formDataOrder.append(
        `order_items[${i}][number]`,
        +addModalOrder.selectedProducts[i].number
      );
      formDataOrder.append(
        `order_items[${i}][discount]`,
        +addModalOrder.selectedProducts[i].discount
      );
      // }
    }

    formDataOrder.append("type", "0");
    formDataOrder.append("order_type", "0");
    formDataOrder.append("send_trackingcode", addModalOrder.OrderNumber);
    formDataOrder.append(
      "sendtm",
      addModalOrder.DateSubmit ? addModalOrder.DateSubmit.unix : "1"
    );
    formDataOrder.append("despription", addModalOrder.desc);
    formDataOrder.append(
      "rescipient_fname",
      addModalOrder.rescipient_fname ? addModalOrder.rescipient_fname : ""
    );
    formDataOrder.append(
      "rescipient_lname",
      addModalOrder.rescipient_lname ? addModalOrder.rescipient_lname : ""
    );
    formDataOrder.append(
      "rescipient_mobile",
      addModalOrder.rescipient_mobile ? addModalOrder.rescipient_mobile : ""
    );
    formDataOrder.append(
      "rescipient_address",
      addModalOrder.rescipient_address ? addModalOrder.rescipient_address : ""
    );
    formDataOrder.append(
      "rescipient_postalcode",
      addModalOrder.rescipient_postalcode
        ? addModalOrder.rescipient_postalcode
        : ""
    );
    if (addModalOrder.userName.value == "create") {
      formDataOrder.append("user_fname", addModalOrder.user_fname);
      formDataOrder.append("user_lname", addModalOrder.user_lname);
      formDataOrder.append("user_mobile", addModalOrder.user_mobile);
    } else {
      formDataOrder.append("uid", addModalOrder.userInfo.id);
    }
    // formDataOrder.append("uid", addModalOrder.userInfo.id);
    formDataOrder.append("img", addModalOrder.choseFile);

    for (var [key, value] of formDataOrder.entries()) {
    }
    sendRequest2("addorder_new", formDataOrder).then(data => {
      console.log("status0", data);
      if (data.data.status == 1) {
        toast.success("سفارش با موفقیت ثبت شد.");
        // setUpdateProduct((prev) => !prev);
        document.querySelector("#AddOrderModal .btn-close").click();
        orderUpdater(prev => {
          return !prev;
        });
        setAddModalOrder({
          userName: "",
          DateReceived: "",
          discount: "",
          totalPrice: "",
          DatePayment: "",
          DateSubmit: "",
          OrderNumber: "",
          debtAmount: "",
          desc: "",
          user_fname: "",
          user_lname: "",
          user_mobile: "",
          phoneNumber: "",
          addProduct: "",
          products: [],
          price: "",
          address: "",
          choseFile: "",
          selectedProducts: [],
          userInfo: {},
          rescipient_fname: "",
          rescipient_lname: "",
          rescipient_mobile: "",
          rescipient_postalcode: "",
          rescipient_address: ""
        });
        setTempValue({
          title: "",
          price: "",
          id: 0,
          number: 0,
          discount: 0,
          choseFile: "",
          url: ""
        });
      } else {
        toast.error("مشکلی در ثبت سفارش پیش آمده است.");
      }
    });
  };

  const modalVar = (
    <div className="modal fade addOrder" id="AddOrderModal">
      <div className="modal-dialog modal-lg ">
        {/* {Object.keys(selectedItem).length && ( */}
        <div
          className="modal-content"
          style={{
            backgroundColor: "white",
            borderRadius: "15px",
            padding: "15px"
          }}
        >
          <div class="modal-header">
            <h5 class="modal-title"> افزودن سفارشات</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className=" d-flex order-item2 mx-4 mt-2 p-4">
            <div>
              <form className="form row w-100">
                {/* مشخصات کاربر */}
                <div
                  style={{
                    backgroundColor: "#203b8c",
                    width: "200px",
                    borderRadius: "30px 0px 0px 30px"
                  }}
                >
                  <p
                    style={{
                      marginTop: "10px",
                      color: "white"
                    }}
                  >
                    مشخصات کاربر:
                  </p>
                </div>
                <div
                  className="row pt-3 "
                  style={{
                    borderBottom: "1px solid #dee2e6",
                    borderRight: "1px solid #dee2e6",
                    marginTop: "20px",
                    marginRight: "20px"
                  }}
                >
                  <div className=" col-12 col-lg-6 d-flex container-responsive">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="nameU"
                        style={{
                          color: "#707070",
                          whiteSpace: "nowrap"
                        }}
                      >
                        نام کاربر:
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl"
                        // width: "65%",
                      }}
                    >
                      <Select
                        options={defaultUser}
                        // isMulti
                        id="nameU"
                        value={addModalOrder.userName}
                        onChange={value => {
                          // changeHandler(value.value, "id");
                          // changeHandler(value.mobile, "id");
                          //
                          changeHandler(
                            {
                              id: value.value,
                              name: value.label,
                              mobile: value.mobile
                            },
                            "userInfo"
                          );
                          changeHandler(value, "userName");
                          if (value.value == "create") {
                            setDisplayStatus("d-block");
                          } else {
                            setDisplayStatus("d-none");
                          }
                        }}
                      />
                      {/* <input
                        type="text"
                        required
                        className="form-control"
                        id="nameU"
                        value={addModalOrder.userName}
                        onChange={(e) => {
                          changeHandler(e.target.value, "userName");
                        }}
                      /> */}
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            validateValues.userName == "" ? "visible" : "hidden"
                        }}
                      >
                        لطفا نام کاربر را وارد کنید.
                      </p>
                    </div>
                  </div>

                  {addModalOrder.userName.value != "create" ? (
                    <div className=" col-12 col-lg-6 d-flex container-responsive">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="Number"
                          style={{
                            color: "#707070",
                            whiteSpace: "nowrap"
                          }}
                        >
                          شماره موبایل:
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl"
                          // width: "65%",
                        }}
                      >
                        <input
                          type="text"
                          required
                          className="form-control"
                          id="Number"
                          value={
                            addModalOrder.userInfo.mobile == undefined
                              ? ""
                              : addModalOrder.userInfo.mobile
                          }
                          // شما فلان چیز رو خریدید
                          // توضیحات: .......

                          // onChange={(e) => {
                          //   if (
                          //     addModalOrder.userName.__isNew__ &&
                          //     !isNaN(e.target.value)
                          //   ) {
                          //     setAddModalOrder((prev) => {
                          //       return {
                          //         ...prev,
                          //         userName: {
                          //           ...prev.userName,
                          //           phoneNumber: e.target.value,
                          //         },
                          //       };
                          //     });
                          //   }
                          // }}
                        />

                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              validateValues.phoneNumber == ""
                                ? "visible"
                                : "hidden"
                          }}
                        >
                          شماره همراه وارد شده اشتباه است.
                        </p>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* ایجادکاربر جدید */}
                  <div
                    className={`d-flex flex-wrap ${displayStatus} rounded mb-2 new-user`}
                    style={{ border: "1px dashed lightgray" }}
                  >
                    <div className=" p-1 col-12 col-md-6">
                      <label>نام کاربر:</label>
                      <input
                        className="form-control"
                        type="text"
                        value={addModalOrder.user_fname}
                        onChange={e => {
                          changeHandler(e.target.value, "user_fname");
                        }}
                      ></input>
                    </div>
                    <div className=" p-1 col-12 col-md-6">
                      <label>فامیل کاربر:</label>
                      <input
                        className="form-control"
                        type="text"
                        value={addModalOrder.user_lname}
                        onChange={e => {
                          changeHandler(e.target.value, "user_lname");
                        }}
                      ></input>
                    </div>
                    <div className=" p-1 col-12 col-md-6">
                      <label>موبایل کاربر:</label>
                      <input
                        className="form-control"
                        type="text"
                        value={addModalOrder.user_mobile}
                        onChange={e => {
                          changeHandler(e.target.value, "user_mobile");
                        }}
                      ></input>
                    </div>
                  </div>
                  {/* <div className=" col-12 col-lg-6 d-flex ">
                    <div
                      style={{
                        width: "35%",
                        textAlign: "right",
                        marginTop: "5px",
                      }}
                    >
                      <label
                        htmlFor="address"
                        style={{
                          color: "#707070",
                          whiteSpace: "nowrap",
                        }}
                      >
                        آدرس :
                      </label>
                    </div>

                    <div
                      style={{
                        direction: "rtl",
                        width: "65%",
                      }}
                    >
                      <input
                        type="text"
                        required
                        className="form-control"
                        id="address"
                        name="address"
                        value={addModalOrder.address}
                        onChange={(e) => {
                          changeHandler(e.target.value, "address");
                        }}
                      />

                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            validateValues.address == "" ? "visible" : "hidden",
                        }}
                      >
                        لطفا آدرس را وارد کنید .
                      </p>
                    </div>
                  </div> */}
                </div>

                {/* مشخصات گیرنده */}
                <div
                  style={{
                    backgroundColor: "#203b8c",
                    marginTop: "20px",

                    width: "200px",
                    borderRadius: "30px 0px 0px 30px"
                  }}
                >
                  <p
                    style={{
                      marginTop: "10px",
                      color: "white"
                    }}
                  >
                    مشخصات گیرنده:
                  </p>
                </div>
                <div
                  className="row pt-3"
                  style={{
                    borderBottom: "1px solid #dee2e6",
                    borderRight: "1px solid #dee2e6",
                    marginTop: "20px",
                    marginRight: "20px"
                  }}
                >
                  <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="rescipient_fname"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        نام گیرنده:
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl"
                        // , width: "75%"
                      }}
                    >
                      <input
                        type="text"
                        required
                        name="rescipient_fname"
                        className="form-control"
                        id="rescipient_fname"
                        value={addModalOrder.rescipient_fname}
                        onChange={e => {
                          changeHandler(e.target.value, "rescipient_fname");
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="rescipient_lname"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        فامیلی گیرنده :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl"
                        // , width: "75%"
                      }}
                    >
                      <input
                        type="text"
                        required
                        name="rescipient_lname"
                        className="form-control"
                        id="rescipient_lname"
                        value={addModalOrder.rescipient_lname}
                        onChange={e => {
                          changeHandler(e.target.value, "rescipient_lname");
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-flex container-responsive my-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right"
                        // marginTop: "5px",
                      }}
                    >
                      <label
                        htmlFor="rescipient_mobile"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        موبایل گیرنده :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl"
                        // , width: "75%"
                      }}
                    >
                      <input
                        type="text"
                        required
                        name="rescipient_mobile"
                        className="form-control"
                        id="rescipient_mobile"
                        value={addModalOrder.rescipient_mobile}
                        onChange={e => {
                          changeHandler(e.target.value, "rescipient_mobile");
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          display:
                            validateValues.rescipient_mobile == false
                              ? "block"
                              : "none"
                        }}
                      >
                        شماره همراه وارد شده اشتباه است.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-flex container-responsive my-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right"
                        // marginTop: "5px",
                      }}
                    >
                      <label
                        htmlFor="rescipient_mobile"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        کدپستی گیرنده :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl"
                        // , width: "75%"
                      }}
                    >
                      <input
                        type="text"
                        required
                        name="rescipient_postalcode"
                        className="form-control"
                        id="rescipient_postalcode"
                        value={addModalOrder.rescipient_postalcode}
                        onChange={e => {
                          changeHandler(
                            e.target.value,
                            "rescipient_postalcode"
                          );
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          display:
                            validateValues.rescipient_postalcode == false
                              ? "block"
                              : "none"
                        }}
                      >
                        کدپستی 10 رقمی گیرنده را صحیح وارد کنید
                      </p>
                    </div>
                  </div>
                  <div className="col-12 d-flex container-responsive my-2">
                    <div
                      className="labelReceptor"
                      style={{
                        // width: "35%",
                        textAlign: "right"
                        // marginTop: "5px",
                      }}
                    >
                      <label
                        htmlFor="rescipient_mobile"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        آدرس گیرنده :
                      </label>
                    </div>

                    <div
                      className="inputReceptor"
                      style={{
                        direction: "rtl"
                        // , width: "75%"
                      }}
                    >
                      <textarea
                        type="text"
                        required
                        name="rescipient_address"
                        className="form-control w-100"
                        id="rescipient_address"
                        value={addModalOrder.rescipient_address}
                        onChange={e => {
                          changeHandler(e.target.value, "rescipient_address");
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* جزئیات سفارش */}
                <div
                  style={{
                    backgroundColor: "#203b8c",
                    width: "200px",
                    borderRadius: "30px 0px 0px 30px",
                    marginTop: "20px"
                  }}
                >
                  <p
                    style={{
                      marginTop: "10px",
                      color: "white"
                    }}
                  >
                    جزئیات سفارش :
                  </p>
                </div>
                <div
                  className="row align-items-center pt-3 "
                  style={{
                    borderBottom: "1px solid #dee2e6",
                    borderRight: "1px solid #dee2e6",
                    marginTop: "20px",
                    marginRight: "20px"
                  }}
                >
                  <div className="col-12 col-lg-6 d-flex  container-responsive">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="DateSubmit"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        تاریخ ارسال:
                      </label>
                    </div>

                    <div
                      style={{
                        direction: "rtl"
                        // width: "65%",
                      }}
                      className="input"
                    >
                      <DatePicker
                        calendar={persian}
                        locale={persian_fa}
                        inputClass={"date-picker-style form-control"}
                        calendarPosition="bottom-right"
                        id="DateSubmit"
                        value={addModalOrder.DateSubmit}
                        onChange={value => {
                          changeHandler(value, "DateSubmit");
                        }}
                      />
                      {/* <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            validateValues.DateSubmit == ""
                              ? "visible"
                              : "hidden",
                        }}
                      >
                        لطفا تاریخ ارسال را وارد کنید.
                      </p> */}
                    </div>
                  </div>

                  {/* <div
                    className="col-12 col-lg-6 d-flex align-items-baseline container-responsive "
                    style={{ marginBottom: "30px" }}
                  >
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right"
                        // marginTop: "5px",
                      }}
                    >
                      <label
                        htmlFor="OrderNumber"
                        style={{
                          color: "#707070",
                          whiteSpace: "nowrap"
                        }}
                      >
                        کد پیگیری :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl"
                        // width: "65%",
                      }}
                    >
                      <input
                        type="text"
                        required
                        className="form-control"
                        id="OrderNumber"
                        value={addModalOrder.OrderNumber}
                        onChange={e => {
                          if (isNaN(e.target.value))
                            changeHandler(e.target.value, "OrderNumber");
                        }}
                      />
                    </div>
                  </div> */}
                  {/* <div className="col-12 col-lg-6 d-flex  ">
                    <div
                      style={{
                        width: "35%",
                        textAlign: "right",
                        marginTop: "5px",
                      }}
                    >
                      <label
                        htmlFor="debtAmo"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        مانده حساب :
                      </label>
                    </div>

                    <div
                      style={{
                        direction: "rtl",
                        width: "65%",
                      }}
                    >
                      <input
                        type="text"
                        required
                        className="form-control"
                        id="debtAmo"
                        value={addModalOrder.debtAmount.toLocaleString()}
                        onChange={(e) => {
                          if (isNaN(e.target.value))
                            changeHandler(e.target.value, "debtAmount");
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            validateValues.debtAmount == ""
                              ? "visible"
                              : "hidden",
                        }}
                      >
                        لطفا مانده حساب را وارد کنید.
                      </p>
                    </div>
                  </div> */}
                  <div className="col-12 col-lg-6 d-flex container-responsive align-items-baseline mt-3">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="totalPrice"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        مبلغ کل:
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl"
                        //  width: "75%"
                      }}
                    >
                      <input
                        type="text"
                        required
                        className="form-control"
                        id="totalPrice"
                        value={addCommas(
                          +addModalOrder.selectedProducts?.reduce(
                            (total, currentValue) => {
                              return (
                                total +
                                (currentValue.price - currentValue.discount) *
                                  currentValue.number
                              );
                            },
                            0
                          )
                        )}
                        onChange={e => {
                          // changeHandler(
                          //   removeCommas(e.target.value),
                          //   "totalPrice"
                          // );
                          if (!isNaN(e.target.value))
                            changeHandler(e.target.value, "totalPrice");
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            validateValues.totalPrice == ""
                              ? "visible"
                              : "hidden"
                        }}
                      >
                        لطفا مبلغ کل را وارد کنید.
                      </p>
                    </div>
                  </div>
                </div>
                {/* جزئیات محصول */}
                <div className="d-flex ">
                  <div
                    style={{
                      backgroundColor: "#203b8c",
                      width: "200px",
                      borderRadius: "30px 0px 0px 30px",
                      marginTop: "20px",
                      paddingRight: "4px"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "10px",
                        color: "white"
                      }}
                    >
                      جزئیات محصول :
                    </p>
                  </div>
                  <button
                    style={{
                      height: "30px",
                      marginTop: "30px",
                      marginRight: "5px",
                      backgroundColor: "white",
                      border: "none",
                      fontSize: "20px"
                    }}
                    type="button"
                    onClick={() => {
                      if (ValidationDetailsOrder()) {
                        setAddModalOrder(prev => {
                          return {
                            ...prev,
                            selectedProducts: [
                              ...addModalOrder.selectedProducts,
                              tempValue
                            ]
                          };
                        });
                      }
                    }}
                  >
                    <FcPlus></FcPlus>
                  </button>
                </div>

                <div
                  className="row pb-5"
                  style={{
                    borderBottom: "1px solid #dee2e6",
                    borderRight: "1px solid #dee2e6",
                    marginTop: "20px",
                    marginRight: "20px"
                  }}
                >
                  <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="addProduct"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        انتخاب محصول :
                      </label>
                    </div>
                    <div
                      className="input"
                      style={{
                        direction: "rtl"
                        // width: "65%",
                      }}
                    >
                      <Select
                        options={defaultProduct}
                        value={tempValue}
                        onChange={e => {
                          setTempValue(e);
                        }}
                      />
                      {/* <select
                        id="addProduct"
                        value={tempValue.id}
                        onChange={(e) => {
                          setTempValue(() => {
                            return {
                              ...productList[e.target.value],
                              number: 0,
                            };
                          });
                        }}
                        className="form-control form-select"
                      >
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              validateValues.title == "" ? "visible" : "hidden",
                          }}
                        >
                          لطفا نام محصول را وارد کنید.
                        </p>

                        {productList.map((value, index) => {
                          return (
                            <option value={value.id}>{value.title}</option>
                          );
                        })}
                      </select> */}
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right"
                      }}
                    >
                      <label
                        htmlFor="addProduct"
                        style={{
                          color: "#707070",
                          whiteSpace: "nowrap",
                          marginTop: "5px"
                        }}
                      >
                        قیمت محصول :
                      </label>
                    </div>
                    <div
                      className="input"
                      style={{
                        direction: "rtl",
                        // width: "60%",
                        marginTop: "0",
                        paddingTop: "0",
                        marginRight: "10px"
                      }}
                    >
                      <p
                        style={{
                          color: "red",
                          margin: "0",
                          padding: "0",
                          marginTop: "5px"
                        }}
                      >
                        {addCommas(tempValue.price)} تومان
                        {/* {tempValue.price.toLocaleString()} */}
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="number"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        تعداد :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl"
                        // width: "65%",
                      }}
                    >
                      <input
                        type="text"
                        name="number"
                        required
                        className="form-control"
                        id="number"
                        value={tempValue.number}
                        onChange={e => {
                          setTempValue(prev => {
                            return {
                              ...prev,
                              number: e.target.value
                            };
                          });
                        }}
                      />

                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          display: !tempValidateValues.number ? "block" : "none"
                        }}
                      >
                        لطفا تعداد را وارد کنید.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="Discount"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        قیمت بعد تخفیف :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl"
                        // width: "65%",
                      }}
                    >
                      <input
                        type="text"
                        name="Discount"
                        required
                        className="form-control"
                        id="Discount"
                        value={addCommas(tempValue.price - tempValue.discount)}
                        onChange={e => {
                          setTempValue(prev => {
                            return {
                              ...prev,
                              discount: removeCommas(e.target.value)
                            };
                          });
                        }}
                      />

                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          display: !tempValidateValues.discount
                            ? "block"
                            : "none"
                        }}
                      >
                        لطفا مبلغ تخفیف را وارد کنید.
                      </p>
                    </div>
                  </div>
                  <p
                    style={{
                      fontSize: "12px",
                      color: "red",
                      display:
                        validateValues.selectedProducts == "" ? "block" : "none"
                    }}
                  >
                    لیست محصولات سفارش نباید خالی باشد.
                  </p>
                  {/* <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                    <div
                      className="
                    label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px",
                      }}
                    >
                      <label
                        htmlFor="choseFile"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        انتخاب فایل :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl",
                        //  width: "75%"
                      }}
                    >
                      <div className="mb-3">
                        <input
                          className="form-control"
                          type="file"
                          id="choseFile"
                          value={tempValue.choseFile.value}
                          onChange={(e) => {
                            setTempValue((prev) => {
                              return { ...prev, choseFile: e.target };
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div> */}
                  {addModalOrder.selectedProducts.map((value, index) => {
                    console.log(
                      "addModalOrder.selectedProducts",
                      addModalOrder.selectedProducts
                    );
                    return (
                      //   <div
                      //     className="pt-3 mt-4 d-flex"
                      //     style={{
                      //       // borderBottom: "1px solid #dee2e6",
                      //       marginTop: "2px"
                      //     }}
                      //   >
                      //     <div className="">
                      //       <img
                      //         // style={{ width: "100%" }}
                      //         // src={"http://grc.tatdemo.ir/uploads/885images.png"}
                      //         src={`http://grc.tatdemo.ir/${value.url}`}
                      //         // src={
                      //         //   value.choseFile.files == undefined
                      //         //     ? ""
                      //         //     : URL.createObjectURL(value.choseFile.files[0])
                      //         // }
                      //         style={{ width: "50px", height: "50px" }}
                      //       />
                      //     </div>
                      //     <div className="">
                      //       <p
                      //         style={{
                      //           fontSize: "13px",
                      //           textAlign: "justify",
                      //           marginTop: "5px",
                      //           marginRight: "6px"
                      //         }}
                      //       >
                      //         شما محصول:
                      //         <span
                      //           style={{ marginRight: "5px", marginLeft: "5px" }}
                      //         >
                      //           {value.label}
                      //         </span>
                      //         به تعداد:
                      //         <span
                      //           style={{
                      //             marginRight: "5px",
                      //             marginLeft: "5px",
                      //             color: "red"
                      //           }}
                      //         >
                      //           {value.number}
                      //         </span>
                      //         با قیمت :
                      //         <span
                      //           style={{
                      //             marginRight: "5px",
                      //             marginLeft: "5px",
                      //             color: "red"
                      //           }}
                      //         >
                      //           {addCommas(value.price.toLocaleString())}
                      //           تومان
                      //         </span>
                      //         و با تخفیف هر واحد
                      //         <span
                      //           style={{
                      //             marginRight: "5px",
                      //             marginLeft: "5px",
                      //             color: "red"
                      //           }}
                      //         >
                      //           {addCommas(value.discount.toLocaleString())}
                      //           تومان
                      //         </span>
                      //         و به مجموع قیمت :
                      //         <span
                      //           style={{
                      //             marginRight: "5px",
                      //             marginLeft: "5px",
                      //             color: "red"
                      //           }}
                      //         >
                      //           {addCommas(
                      //             (value.price - value.discount) * value.number
                      //           )}
                      //         </span>
                      //         تومان سفارش دادید.
                      //       </p>
                      //     </div>
                      //     <div
                      //       className=""
                      //       style={{ width: "5px", textAlign: "left" }}
                      //     >
                      //       <button
                      //         type="button"
                      //         style={{
                      //           border: "none",
                      //           backgroundColor: "#f9f7f8",
                      //           backgroundColor: "white",
                      //           fontSize: "20px"
                      //         }}
                      //         onClick={() => {
                      //           RemoveCounter(index);
                      //         }}
                      //       >
                      //         <HiMinusCircle
                      //           style={{ color: "#35b8e0" }}
                      //         ></HiMinusCircle>
                      //       </button>
                      //     </div>
                      //     <div
                      //       style={{
                      //         borderBottom: "1px solid #dee2e6",
                      //         height: "3px",
                      //         marginRight: "5px"
                      //       }}
                      //     ></div>
                      //   </div>
                      <div className="d-flex flex-row flex-wrap mt-4 shadow px-0">
                        <div className="flex-grow-1">
                          <div className="text-center bg-blue text-white fs-11 p-1">
                            عکس
                          </div>
                          <div className="text-center p-1">
                            <img
                              src={`http://grc.tatdemo.ir/${value.url}`}
                              style={{ width: "30px", height: "30px" }}
                            />
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <div className="text-center bg-blue text-white fs-11 p-1">
                            نام محصول
                          </div>
                          <div className="text-center fs-11 p-1">
                            {value.label}
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <div className="text-center bg-blue text-white fs-11 p-1">
                            تعداد
                          </div>
                          <div className="text-center fs-11 p-1">
                            {value.number}
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <div className="text-center bg-blue text-white fs-11 p-1">
                            قیمت هر محصول
                          </div>
                          <div className="text-center fs-11 p-1">
                            {value.price}
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <div className="text-center bg-blue text-white fs-11 p-1">
                            تخفیف هر محصول
                          </div>
                          <div className="text-center fs-11 p-1">
                            {value.discount}
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <div className="text-center bg-blue text-white fs-11 p-1">
                            مبلغ نهایی
                          </div>
                          <div className="text-center fs-11 p-1">
                            {addCommas(
                              (value.price - value.discount) * value.number
                            )}
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <div className="text-center bg-blue text-white fs-11 p-1">
                            حذف سفارش
                          </div>
                          <div className="text-center fs-11 p-1">
                            <button
                              type="button"
                              style={{
                                border: "none",
                                backgroundColor: "#f9f7f8",
                                backgroundColor: "white",
                                fontSize: "20px"
                              }}
                              onClick={() => {
                                RemoveCounter(index);
                              }}
                            >
                              <HiMinusCircle
                                style={{ color: "#35b8e0" }}
                              ></HiMinusCircle>
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div
                  style={{
                    backgroundColor: "#203b8c",
                    width: "200px",
                    borderRadius: "30px 0px 0px 30px",
                    marginTop: "20px"
                  }}
                >
                  <p
                    style={{
                      marginTop: "10px",
                      color: "white"
                    }}
                  >
                    توضیحات :
                  </p>
                </div>
                <div
                  className="row pt-3"
                  style={{
                    borderBottom: "1px solid #dee2e6",
                    borderRight: "1px solid #dee2e6",
                    marginTop: "20px",
                    marginRight: "20px"
                  }}
                >
                  <div className=" col-12 col-lg-12 container-responsive d-flex mt-2">
                    <div
                      className="labelDesc"
                      style={{
                        // width: "20%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="desc2"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        توضیحات :
                      </label>
                    </div>
                    <div
                      className="inputDesc"
                      style={{
                        direction: "rtl"
                        // width: "100%",
                      }}
                    >
                      <textarea
                        required
                        className="form-control"
                        id="desc2"
                        value={addModalOrder.desc}
                        onChange={e => {
                          changeHandler(e.target.value, "desc");
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            validateValues.desc == "" ? "visible" : "hidden"
                        }}
                      >
                        لطفا توضیحات را وارد کنید.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-end mt-2">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      console.log("validate", validateValues);
                      if (ValidationOrder()) {
                        addOrder();
                      }
                    }}
                  >
                    افزودن
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* )} */}
      </div>
    </div>
  );
  return createPortal(modalVar, document.querySelector("#modals"));
}
